export default __webpack_public_path__ + "static/media/SubDocs.af09901e.xlsx";